import _ from 'lodash';
import workbenchTour1 from 'resources/img/WorkbenchTour1.webp';
import workbenchTour2 from 'resources/img/WorkbenchTour2.webp';
import workbenchTour3 from 'resources/img/WorkbenchTour3.webp';
import workbenchTour4 from 'resources/img/WorkbenchTour4.webp';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { TourModal } from '@/tour/TourModal.molecule';
import { setTourShown } from '@/workbench/workbench.actions';

const TOUR_STEPS = [
  { image: workbenchTour1, heading: 'TOUR.WORKBENCH.STEP_1' },
  { image: workbenchTour2, heading: 'TOUR.WORKBENCH.STEP_2' },
  { image: workbenchTour3, heading: 'TOUR.WORKBENCH.STEP_3' },
  { image: workbenchTour4, heading: 'TOUR.WORKBENCH.STEP_4' },
];

export const TOUR_NAME = 'workbenchOverviewTour';

export const WorkbenchTourModal = () => {
  const workbenchTourShown = useFluxPath(sqWorkbenchStore, () => _.includes(sqWorkbenchStore.toursShown, TOUR_NAME));

  return (
    <TourModal
      tourTitle="TOUR.WORKBENCH.TITLE"
      displayTour={!workbenchTourShown}
      tourSteps={TOUR_STEPS}
      testId="workbenchTour"
      trackName="workbench"
      onClose={() => setTourShown(TOUR_NAME)}
    />
  );
};
